"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapToDomainAdMachine = mapToDomainAdMachine;
function mapToDomainAdMachine(dto) {
    return {
        id: dto.id,
        code: dto.code,
        name: dto.name,
        siteName: dto.siteName,
    };
}
